import { Header as AinautenHeader } from "@ainauten/ui/Header";
import { Footer as AinautenFooter } from "@ainauten/ui/Footer";

export function ShellHeader() {
  return (
    <AinautenHeader
      product="design"
      activeApp="design"
      variant="tool"
      locale="de"
      className="design-shell-header"
      actions={<a className="design-header-faq" href="#faq">FAQ</a>}
    />
  );
}

export function ShellFooter() {
  return <AinautenFooter product="design" locale="de" variant="compact" />;
}
